module.exports = __webpack_public_path__ + "media/bootstrap-icons/badge-tm-3bd5a8b9.svg";